<template lang="pug">
div
  p(v-if="status=='not-found'") Not Found
  ImageTwoColumn(v-if="status=='ok' && data.style=='ImageTwoColumn'" :items="data.section" :links="data.link")
  Simple(v-if="status=='ok' && data.style=='Simple'" :items="data.section" :links="data.link")
  Timeline(v-if="status=='ok' && data.style=='Timeline'" :items="data.section" :links="data.link")
  TimelineOneSide(v-if="status=='ok' && data.style=='TimelineOneSide'" :items="data.section" :links="data.link")
</template>

<script>
import ImageTwoColumn from '@/views/ImageTwoColumn.vue'
import Simple from '@/views/Simple.vue'
import Timeline from '@/views/Timeline.vue'
import TimelineOneSide from '@/views/TimelineOneSide.vue'
import config from '@/config'

export default {
  data: () => ({
    data: {},
    status: null
  }),
  components: {
    ImageTwoColumn,
    Simple,
    Timeline,
    TimelineOneSide
  },
  mounted () {
    this.getData()
  },
  watch: {
    $route() {
      this.getData()
    }
  },
  methods: {
    async getData() {
      this.status = 'loading'
      let response = await fetch(`${config.strapiBase}/dashboards?slug=${this.$route.params.slug}`)
      if(!response.ok) {
        this.status = 'error'
        return
      }

      let json = await response.json()
      if(json.length == 0) {
        this.status = 'not-found'
        return
      }

      this.data = json[0]
      document.title = json[0].title
      this.status = 'ok'

      console.log(json[0])
      if(json[0].redirect)
        window.location.href = json[0].redirect
    }
  }
}
</script>